"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const Star_1 = __importDefault(require("@kyruus/react-ikons/Star"));
const individual_review_styles_1 = require("./individual-review.styles");
const search_term_highlighter_1 = __importDefault(require("./search-term-highlighter"));
const messages_1 = __importDefault(require("../../lib/messages"));
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
const Review = ({ review, searchTerm, intl }) => {
    const { review_date, body, author_display_name } = review;
    const parsedRating = typeof review.rating === 'string'
        ? parseFloat(review.rating)
        : review.rating;
    const rating = parsedRating <= 0 ? 0 : parsedRating;
    const starCount = (0, utils_1.getReviewStarCount)(rating);
    const stars = [...Array(starCount).keys()].map((i) => (react_1.default.createElement(individual_review_styles_1.StarContainer, { key: i },
        react_1.default.createElement(Star_1.default, { "aria-hidden": true }))));
    const dateContainer = (react_1.default.createElement(individual_review_styles_1.DateContainer, { itemProp: "dateCreated" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, Object.assign(Object.assign({}, messages_1.default.reviewsReviewDate), { values: { date: (0, utils_1.getReviewDateString)(review_date) } })))));
    const bodyContainer = (react_1.default.createElement(individual_review_styles_1.BodyContainer, { itemProp: "reviewBody" },
        react_1.default.createElement(search_term_highlighter_1.default, { searchTerm: searchTerm }, body)));
    return (react_1.default.createElement("div", { "data-testid": "individual-review", itemProp: "review", itemScope: true, itemType: "https://schema.org/Review" },
        react_1.default.createElement("meta", { itemProp: "author", itemType: "http://schema.org/Person", content: author_display_name || 'Anonymous' }),
        rating ? (react_1.default.createElement("div", { itemProp: "reviewRating", itemScope: true, itemType: "https://schema.org/Rating" },
            react_1.default.createElement(individual_review_styles_1.ReviewHeader, null,
                react_1.default.createElement(individual_review_styles_1.StarsContainer, null, stars),
                react_1.default.createElement(styles_1.IndividualReviewRatings, { itemProp: "ratingValue", content: starCount.toString() },
                    react_1.default.createElement("span", { className: "sr-only" }, `${intl.formatMessage(messages_1.default.ariaStarRatingsIndividualReview, {
                        rating: starCount
                    })}`),
                    react_1.default.createElement("span", { "aria-hidden": true }, `${starCount} ${intl.formatMessage(messages_1.default.ratingScale)}`)),
                dateContainer),
            bodyContainer,
            react_1.default.createElement("meta", { itemProp: "worstRating", content: "1" }),
            react_1.default.createElement("meta", { itemProp: "bestRating", content: "5" }))) : (react_1.default.createElement("div", null,
            react_1.default.createElement(individual_review_styles_1.ReviewHeader, null,
                react_1.default.createElement(individual_review_styles_1.NoRating, null,
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewNoRating))),
                dateContainer),
            bodyContainer))));
};
exports.default = (0, intl_1.injectIntl)(Review);
//# sourceMappingURL=individual-review.js.map